// row[0-16], col[1-12]
export const data = [
  'C',
  'B',
  'A',
  'G',
  'F',
  'E',
  'D',
  'C',
  'B',
  'A',
  'G',
  'F',
  'E',
  'D',
  'C',
  'B',
  'A',
]
